// 0 = Disabled 1 = Planned 2 = Enabled
export enum MaintenanceStatus {
  Disabled,
  Planned,
  Enabled,
}

export type MaintenanceInformation = {
  maintenanceStatus: MaintenanceStatus
  maintenanceInProgressMessage: Nullable<string>
  plannedMaintenanceStartDate: Nullable<DateTime>
  plannedMaintenanceEndDate: Nullable<DateTime>
  enablePreMaintenance: boolean | null
  preMaintenanceStartDate: Nullable<DateTime>
  preMaintenanceMessage: Nullable<string>
}

export type BannerMessageSettings = {
  settingGroupName: Nullable<string>
  bannerNotificationStartDate: Nullable<DateTime>
  bannerNotificationEndDate: Nullable<DateTime>
  isBannerMessageEnable: boolean | null
  bannerMessage: Nullable<string>
}

// 0 = Office 1 = Vessel
export enum SiteType {
  Office,
  Vessel,
}

export type SystemInformation = {
  buildVersion: string
  siteType: SiteType
  defaultCustomer: Nullable<string>
  maintenanceInformation: MaintenanceInformation
  specialMessage?: Nullable<string>
  bannerMessageSettings: BannerMessageSettings
}

type CustomerCurrentInstallation = {
  id: number
  name: string
  isActive: boolean
  serialNumber: string
  databaseVersion: string
  locationGroupId: Nullable<string>
  locationTypeId: string
  defaultCategorySetId: string
  isOffice: boolean
}

export type CustomerInformationCustomization = {
  hasLogonLogo: boolean
  hasMenuLogo: boolean
  hasStartupImage: boolean
  logonLogoTimeStamp: Nullable<string>
  menuLogoTimeStamp: string
  startupImageTimeStamp: string
  landingPageSettings: CustomizationLandingPageSettings
}

export type CustomizationLandingPageSettings = {
  continueSectionHeader: string
  newSectionHeader: string
  popularSectionHeader: string
  scheduleSectionHeader: string
  updatedSectionHeader: string
  isContinueSectionHeaderActive: boolean
  isNewSectionHeaderActive: boolean
  isPopularSectionHeaderActive: boolean
  isScheduleSectionHeaderActive: boolean
  isUpdatedSectionHeaderActive: boolean
}

export type CustomerInformation = {
  isInstallationRegistered: boolean
  currentInstallation: CustomerCurrentInstallation
  companyName: string
  databaseName: string
  customization: CustomerInformationCustomization
  maintenanceInformation: MaintenanceInformation
  ssoSettings: SsoInformation
  domainName?: string
  customerId: string
  bannerMessageSettings: BannerMessageSettings
  customerAlias: string
}

export type SsoInformation = {
  enableSso: boolean
  forceSsoOnly: boolean
  hasIconImage: boolean
  iconImageTimeStamp: string
  providerName: string
  keyCloakServerUrl: string
  ssoClientId: string
}

export type SsoSettings = {
  isSsoEnabled: boolean
  isSsoConfigValid: boolean
  isForcedSsoEnabled: boolean
  hasIconImage: boolean
  iconImageTimeStamp: string
  ssoProviderName: string
  ssoProviderIconUrl: Nullable<string>
  realm?: string
}
